// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BlockRecord_Wrapper__he3bh","Text":"BlockRecord_Text__JC_ir","WrapperBtnRecord":"BlockRecord_WrapperBtnRecord__juwRy"};